import { __DEV__ } from "@chakra-ui/utils";
import { createContext } from "@chakra-ui/react-utils";
import * as React from "react";
import { useCheckboxGroup } from "./use-checkbox-group";
var [CheckboxGroupProvider, useCheckboxGroupContext] = createContext({
  name: "CheckboxGroupContext",
  strict: false
});
export { useCheckboxGroupContext };
/**
 * Used for multiple checkboxes which are bound in one group,
 * and it indicates whether one or more options are selected.
 *
 * @see Docs https://chakra-ui.com/checkbox
 */

export var CheckboxGroup = props => {
  var {
    colorScheme,
    size,
    variant,
    children,
    isDisabled
  } = props;
  var {
    value,
    onChange
  } = useCheckboxGroup(props);
  var group = React.useMemo(() => ({
    size,
    onChange,
    colorScheme,
    value,
    variant,
    isDisabled
  }), [size, onChange, colorScheme, value, variant, isDisabled]);
  return /*#__PURE__*/React.createElement(CheckboxGroupProvider, {
    value: group
  }, children);
};

if (__DEV__) {
  CheckboxGroup.displayName = "CheckboxGroup";
}
//# sourceMappingURL=checkbox-group.js.map